'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DrawerFooter", {
    enumerable: true,
    get: function() {
        return DrawerFooter;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useDrawerFooter = require("./useDrawerFooter");
const _renderDrawerFooter = require("./renderDrawerFooter");
const _useDrawerFooterStylesstyles = require("./useDrawerFooterStyles.styles");
const DrawerFooter = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useDrawerFooter.useDrawerFooter_unstable)(props, ref);
    (0, _useDrawerFooterStylesstyles.useDrawerFooterStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useDrawerFooterStyles_unstable')(state);
    return (0, _renderDrawerFooter.renderDrawerFooter_unstable)(state);
});
DrawerFooter.displayName = 'DrawerFooter';
